import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  appBar: {
    backgroundColor: 'transparent',
    boxShadow: 'none',
  },
  tabs: {
    position: 'relative',

    '& .MuiTabs-indicator': {
      height: 3,
      backgroundColor: theme.palette.primary.main,
    },
  },
  scrollButtons: {
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',

    width: theme.spacing(7),
    height: '100%',

    background:
      'linear-gradient(90deg, #FFFFFF 21.69%, rgba(255, 255, 255, 0.81) 61.25%, rgba(255, 255, 255, 0) 100%)',
    color: theme.palette.neutral.main,
    zIndex: theme.zIndex.mobileStepper,
    cursor: 'pointer',

    '&[disabled]': {
      display: 'none',
    },

    '& svg': {
      transform: 'rotate(90deg)',
      height: theme.spacing(3),
    },

    '&:last-child': {
      right: 0,
      transform: 'scaleX(-1)',
    },
  },
}))

export default useStyles
